module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "rounded-lg",
    attrs: {
      "outlined": ""
    }
  }, [(!_vm.short) ? _c('v-img', {
    attrs: {
      "src": '/static/calendarEventImages/img_birthday_1x.jpg',
      "height": "100px"
    }
  }, [_c('v-card-title', {
    staticClass: "white--text"
  }, [_vm._v("Geburtstagsliste")])], 1) : _c('v-card-title', [_vm._v("Geburtstagsliste")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.geburtstage.length === 0) ? _c('div', {
    staticClass: "body-2 pa-4"
  }, [_vm._v("Keine anstehenden Geburtstage")]) : _vm._e(), _vm._v(" "), _c('v-simple-table', {
    staticClass: "mb-0 rounded-lg",
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('tbody', _vm._l((_vm.geburtstage), function(item) {
    return _c('tr', {
      key: item.id,
      on: {
        "click": function($event) {
          _vm.bbr = item.bbr;
          _vm.showKontakt = true;
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.$filters.date(item.geburtsdatum, "DD.MM.")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.bbrID, _vm.bbrbbr)) + " (" + _vm._s(item.alter) + " Jahre)")])])
  }), 0)]), _vm._v(" "), _c('dialogKontakt', {
    attrs: {
      "visible": _vm.showKontakt,
      "bbr": _vm.bbr
    },
    on: {
      "update:visible": function($event) {
        _vm.showKontakt = $event
      },
      "close": function($event) {
        _vm.showKontakt = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a89d5eaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module_klein/geburtstage.vue
// module id = 803
// module chunks = 15